import isString from 'lodash/isString';
import { safeParseURL } from './safeParseURL';

export const modifyUrlString = ({ baseUrl = '', path = '', search = {} }) => {
  let normalizedPath = path;
  let normalizedSearchParams = search;

  if (!isString(normalizedPath)) {
    normalizedPath = '';
  }

  if (!normalizedSearchParams || typeof normalizedSearchParams !== 'object') {
    normalizedSearchParams = {};
  }

  const newUrl = safeParseURL(normalizedPath, baseUrl);

  if (!newUrl) {
    return '';
  }

  Object.entries(normalizedSearchParams).forEach(([key, value]) => {
    if (value != null) {
      newUrl.searchParams.set(key, String(value));
    }
  });

  return newUrl.toString();
};
